var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"application"}},[(_vm.userLogged)?_c('SideBar'):_vm._e(),(_vm.isLoading)?_c('Loader'):_vm._e(),_c('v-main',{class:_vm.userLogged ? 'contain' : ''},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }